import React from "react";

export const Header = (props) => {
  return (
    <header
     id="header"
    >
      <div className="intro">
        <div>
          <div>
            <div className="logo"> </div>
            <div className="menu">
                {/* Render children here */}
                {props.children}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
